/**
 * 路由表定义
 * 功能：history 模式，约 40 个路由，含基础配置/账号管理/邮件中心/Amazon 邮件/Ozon 邮件/售后管理/系统日志等模块，keep-alive 缓存策略统一开启
 */
import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
import Layout from '@/components/layout' //Layout 是架构组件，不在后台返回，在文件里单独引入
// 首页与 403 无权限页路由
var constantRouterMap = [{
  path: "/",
  component: Layout,
  name: "home",
  meta: {
    title: "首页",
    icon: "home",
    redirect: "/homePage",
    keepAlive: true
  },
  children: [{
    path: "/homePage",
    name: "homePage",
    component: () => import("@/views/homePage/index"),
    meta: {
      title: "首页",
      icon: "home",
      keepAlive: true,
    }
  }],
},
{
  path: "/403",
  name: "403",
  component: () => import("@/views/center/403"),
  meta: {
    title: "403",
    icon: "403",
    keepAlive: true
  },
  hidden: true
},
// 基础配置模块路由（模板/客服/标签/Amazon 客服/回复规则/Ozon 客服）
{
  path: "/basicConfig",
  component: Layout,
  name: "basicConfig",
  meta: {
    title: "基础配置",
    icon: "basicConfig",
    redirect: "/basicConfig",
    keepAlive: true
  },
  children: [{
    path: "/templateConfig",
    name: "templateConfig",
    component: () => import("@/views/basicConfig/templateConfig/index"),
    meta: {
      title: "模板配置",
      icon: "twoMenu",
      keepAlive: true,
    }
  }, {
    path: "/customerService",
    name: "customerService",
    component: () => import("@/views/basicConfig/customerService/index"),
    meta: {
      title: "ebay客服管理",
      icon: "twoMenu",
      keepAlive: true,
    }
  }, {
    path: "/labelConfig",
    name: "labelConfig",
    component: () => import("@/views/basicConfig/labelConfig/index"),
    meta: {
      title: "标签配置",
      icon: "twoMenu",
      keepAlive: true,
    }
  },{
    path: "/amazonCustomer",
    name: "amazonCustomer",
    component: () => import("@/views/basicConfig/amazonCustomer/index"),
    meta: {
      title: "amazon客服管理",
      icon: "twoMenu",
      keepAlive: true,
    }
  },{
    path: "/ruleConfig",
    name: "ruleConfig",
    component: () => import("@/views/basicConfig/ruleConfig/index"),
    meta: {
      title: "无需回复规则配置",
      icon: "twoMenu",
      keepAlive: true,
    }
  },{
    path: "/OzonCustomer",
    name: "OzonCustomer",
    component: () => import("@/views/basicConfig/OzonCustomer/index"),
    meta: {
      title: "Ozon客服管理",
      icon: "twoMenu",
      keepAlive: true,
    }
  },{
    // Outlook 邮箱授权
    path: "/outlookAccount",
    name: "outlookAccount",
    component: () => import("@/views/basicConfig/outlookAccount/index"),
    meta: {
      title: "Outlook邮箱授权",
      icon: "twoMenu",
      keepAlive: true,
    }
  }],
},
// 账号管理模块路由（eBay/Amazon 账号）
{
  path: "/accountMangement",
  component: Layout,
  name: "accountMangement",
  meta: {
    title: "账号管理",
    icon: "twoMenu",
    redirect: "/ebayAccount",
    keepAlive: true
  },
  children: [{
    path: "/ebayAccount",
    name: "ebayAccount",
    component: () => import("@/views/accountMangement/ebay/index"),
    meta: {
      title: "ebay账号管理",
      icon: "twoMenu",
      keepAlive: true,
    }
  }, {
    path: "/amazonAccount",
    name: "amazonAccount",
    component: () => import("@/views/accountMangement/amazon/index"),
    meta: {
      title: "amazon账号管理",
      icon: "twoMenu",
      keepAlive: true,
    }
  }],
},
// 邮件中心（eBay）模块路由
{
  path: "/emailCenter",
  component: Layout,
  name: "emailCenter",
  meta: {
    title: "邮件中心",
    icon: "twoMenu",
    keepAlive: true
  },
  children: [ {
    path: "/DraftBox",
    name: "DraftBox",
    component: () => import("@/views/emailCenter/DraftBox/index"),
    meta: {
      title: "草稿箱",
      icon: "DraftBox",
      keepAlive: true,
    }
  }, {
    path: "/eabyInbox",
    name: "eabyInbox",
    component: () => import("@/views/emailCenter/eabyInbox/index"),
    meta: {
      title: "收件箱",
      icon: "twoMenu",
      keepAlive: true,
    }
  }, {
    path: "/emailFromEaby",
    name: "emailFromEaby",
    component: () => import("@/views/emailCenter/emailFromEaby/index"),
    meta: {
      title: "ebay邮件列表",
      icon: "twoMenu",
      keepAlive: true,
    }
  }, {
    path: "/ebaySendEmail",
    name: "ebaySendEmail",
    component: () => import("@/views/emailCenter/sendEmail/index"),
    meta: {
      title: "ebay已发送",
      icon: "twoMenu",
      keepAlive: true,
    }
  },{
    path: "/ebayImportantEmail",
    name: "ebayimportantEmail",
    component: () => import("@/views/emailCenter/importantEmail/index"),
    meta: {
      title: "ebay重要邮件",
      icon: "twoMenu",
      keepAlive: true,
    }
  },{
    path: "/ebayTodoMail",
    name: "ebayTodoMail",
    component: () => import("@/views/emailCenter/todoMail/index"),
    meta: {
      title: "ebay待办邮件",
      icon: "twoMenu",
      keepAlive: true,
    }
  },{
    path: "/ebayDustbin",
    name: "ebayDustbin",
    component: () => import("@/views/emailCenter/dustbin/index"),
    meta: {
      title: "ebay垃圾箱",
      icon: "twoMenu",
      keepAlive: true,
    }
  }, {
    path: "/senEmail",
    name: "senEmail",
    component: () => import("@/views/emailCenter/senEmail"),
    meta: {
      title: "ebay邮件发送",
      icon: "twoMenu",
      keepAlive: true,
    }
  }],
},
// Amazon 邮件管理模块路由
{
  path: "/amazonemail",
  component: Layout,
  name: "amazonemail",
  meta: {
    title: "Amazon邮件管理",
    icon: "twoMenu",
    keepAlive: true
  },
  children: [
    {
    path: "/replay",
    name: "replay",
    component: () => import("@/views/amazonemail/components/replay"),
    meta: {
      title: '邮件详情'
    },
    hidden: true
  },
  {
    path: "/emailList",
    name: "emailList",
    component: () => import("@/views/amazonemail/emailList/index"),
    meta: {
      title: "Amazon邮件列表",
      icon: "twoMenu",
      keepAlive: true,
    }
  }, {
    path: "/sendEmailadd",
    name: "sendEmailadd",
    component: () => import("@/views/amazonemail/sendemailadd"),
    meta: {
      title: "Amazon邮件发送",
      icon: "twoMenu",
      keepAlive: true,
    }
  },{
    path: "/inbox",
    name: "inbox",
    component: () => import("@/views/amazonemail/inbox/index"),
    meta: {
      title: "Amazon收件箱",
      icon: "twoMenu",
      keepAlive: true,
    }
  },{
    path: "/importantEmail",
    name: "importantEmail",
    component: () => import("@/views/amazonemail/importantEmail/index"),
    meta: {
      title: "Amazon重要邮件",
      icon: "twoMenu",
      keepAlive: true,
    }
  },{
    path: "/todoMail",
    name: "todoMail",
    component: () => import("@/views/amazonemail/todoMail/index"),
    meta: {
      title: "Amazon待办邮件",
      icon: "twoMenu",
      keepAlive: true,
    }
  },{
    path: "/sendMail",
    name: "sendMail",
    component: () => import("@/views/amazonemail/sendMail/index"),
    meta: {
      title: "Amazon已发送",
      icon: "twoMenu",
      keepAlive: true,
    }
  },{
    path: "/dustbin",
    name: "dustbin",
    component: () => import("@/views/amazonemail/dustbin/index"),
    meta: {
      title: "Amazon垃圾箱",
      icon: "twoMenu",
      keepAlive: true,
    }
  },{
    path: "/drafts",
    name: "drafts",
    component: () => import("@/views/amazonemail/drafts/index"),
    meta: {
      title: "Amazon草稿箱",
      icon: "twoMenu",
      keepAlive: true,
    }
  },],
// Ozon 邮件管理模块路由
},{
  path: "/OzonEmail",
  component: Layout,
  name: "OzonEmail",
  meta: {
    title: "Ozon邮件管理",
    icon: "twoMenu",
    keepAlive: true
  },
  children: [
    {
    path: "/replay",
    name: "OzonReplay",
    component: () => import("@/views/OzonEmail/components/replay"),
    meta: {
      title: '邮件详情'
    },
    hidden: true
  },
  {
    path: "/OzonEmailList",
    name: "OzonEmailList",
    component: () => import("@/views/OzonEmail/OzonEmailList/index"),
    meta: {
      title: "Ozon邮件列表",
      icon: "twoMenu",
      keepAlive: true,
    }
  }],
// 售后管理模块路由（退款单/退款记录/中差评）
},{
  path: "/afterSale",
  component: Layout,
  name: "afterSale",
  meta: {
    title: "售后管理",
    icon: "accountMangement",
    redirect: "/afterSale",
    keepAlive: true
  },
  children: [{
    path: "/eBayRefund",
    name: "eBayRefund",
    component: () => import("@/views/afterSale/eBayRefund/index"),
    meta: {
      title: "eBay退款单",
      icon: "twoMenu",
      keepAlive: true,
    }
  },{
    path: "/AmazonRefund",
    name: "AmazonRefund",
    component: () => import("@/views/afterSale/AmazonRefund/index"),
    meta: {
      title: "Amazon退款单",
      icon: "twoMenu",
      keepAlive: true,
    }
  },{
    path: "/AmazonRefundData",
    name: "AmazonRefundData",
    component: () => import("@/views/afterSale/AmazonRefundData/index"),
    meta: {
      title: "Amazon退款记录列表",
      icon: "twoMenu",
      keepAlive: true,
    }
  },{
    path: "/eBayEvaluate",
    name: "eBayEvaluate",
    component: () => import("@/views/afterSale/eBayEvaluate/index"),
    meta: {
      title: "eBay中差评列表",
      icon: "twoMenu",
      keepAlive: true,
    }
  },{
    path: "/AmazonEvaluate",
    name: "AmazonEvaluate",
    component: () => import("@/views/afterSale/AmazonEvaluate/index"),
    meta: {
      title: "Amazon中差评列表",
      icon: "twoMenu",
      keepAlive: true,
    }
  }],
},
// 系统日志模块路由
{
  path: "/log",
  component: Layout,
  name: "log",
  meta: {
    title: "系统日志",
    icon: "accountMangement",
    redirect: "/logInfo",
    keepAlive: true
  },
  children: [{
    path: "/logInfo",
    name: "logInfo",
    component: () => import("@/views/log/index"),
    meta: {
      title: "系统日志",
      icon: "twoMenu",
      keepAlive: true,
    }
  }],
},
]
export default new Router({
  mode: "history",
  base: process.env.publicPath,
  routes: constantRouterMap,
});